.fullScreen {
  height: 100%;
}

.closeButton {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 2;
}
